import {
  ACT_USERS_FETCH_INIT,
  ACT_USERS_FETCH_200, ACT_UPDATE_SELECTED_USER,
} from '../constants/actions';

export const fetchUsersInitAction = () => ({
  type: ACT_USERS_FETCH_INIT,
});

export const fetchUsersSuccessAction = data => ({
  type: ACT_USERS_FETCH_200,
  payload: data,
});

export const updateSelectedUserAction = data => ({
  type: ACT_UPDATE_SELECTED_USER,
  payload: data,
});
